import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Grid,
  IconButton,
  TextField,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import WithdrawPointsModal from "./WithdrawPointsModal";
import PointsSummaryBanner from "./PointsSummaryBanner";
import TooltipModal from "./TooltipModal";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";







import { useNavigate } from "react-router-dom";







const baseURL = process.env.REACT_APP_VJONEPARIVAAR_API_URL;

const formatPoints = (value) =>
  new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);

const axiosInstance = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});


const EWallet = () => {
  const [openModal, setOpenModal] = useState(false);
  const [loadingTransactions, setLoadingTransactions] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [sortDesc, setSortDesc] = useState(true);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [balancePoints, setBalancePoints] = useState(0);
  const [fosFinalReedemableBalance, setFosFinalReedemableBalance] = useState(0);
  const [walletStanding, setWalletStanding] = useState(null);
  const [activeQuarter, setActiveQuarter] = useState(null);
  const [loadingStanding, setLoadingStanding] = useState(false);

  // TooltipModal state now stores entire transaction object
  const [tooltipModalOpen, setTooltipModalOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const dispatch = useDispatch();
  const { fosId } = useSelector((state) => state.Auth.user);

  const navigate = useNavigate();
const loggedInUser = useSelector((state) => state.Auth.user);





const isWalletVisible = React.useMemo(() => {
  return loggedInUser?.type === "FOS" && loggedInUser?.isWalletVisible === true;
}, [loggedInUser?.type, loggedInUser?.isWalletVisible]);






  const fetchWalletBalance = async () => {
    try {
      const response = await axiosInstance.get(`/fosWallet/fosWalletBalance?fos_id=${fosId}`);
      setBalancePoints(response?.data?.data?.totalBalance);
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
  };

  const handleWithdrawModalClose = async () => {
    await getfosFinalReedemableBalance();
    await fetchWalletBalance();
    await fetchFosWalletTransactions();
    setOpenModal(false);
  };

  const fetchFosWalletTransactions = async () => {
    setLoadingTransactions(true);
    try {
      const response = await axiosInstance.get(`/fosWallet/fosWalletTransactions?fos_id=${fosId}`);
      if (response.data && Array.isArray(response.data.data)) {
        const normalizedTxns = response.data.data.map((txn) => {
          const parsedDate = txn.created_at ? new Date(txn.created_at) : new Date();

          const status = Array.isArray(txn.status)
            ? txn.status.find(Boolean) || txn.status[0]
            : txn.status || "N/A";

          const amount = txn.points ?? txn.amount ?? 0;

          return {
            id: txn.pointHistoryId || txn.transaction_id || Math.random(),
            type: txn.type || "N/A",
            amount,
            date: parsedDate,
            dateFormatted: parsedDate.toLocaleDateString(undefined, {
              year: "numeric",
              month: "short",
              day: "numeric",
              timeZone: "UTC",
            }),
            timeFormatted: parsedDate.toLocaleTimeString(undefined, {
              hour: "2-digit",
              minute: "2-digit",
              timeZone: "UTC",
            }),
            status,
            pointHistoryStatus: txn.pointHistoryStatus || null,
            tds: txn.TDS || null,
            customer: txn.leadName || "Unknown",
            cuid: txn.unique_id || "N/A",
            projectName: txn.projectName || "N/A",
            unitId: txn.unitNo || null,
            wing: txn.wingName || null,
            description: txn.description || "",
            rewardType: txn.reward_type || "",
            payeeVA: txn.payee_va || "",
            payeeName: txn.payee_name || "",
            leadDisplayId: txn.leadDisplayId || "N/A",
            pointHistoryId: txn.pointHistoryId,
            agreementRankInQuarter: txn.agreement_rank_in_quarter ?? null,
            siteVisitRankInProject: txn.site_visit_rank_in_project ?? null,
          };
        });
        setTransactionHistory(normalizedTxns);
      } else {
        setTransactionHistory([]);
      }
    } catch (error) {
      console.error("FOS API getFosDetails error:", error);
      setTransactionHistory([]);
    } finally {
      setLoadingTransactions(false);
    }
  };

  const getfosFinalReedemableBalance = async () => {
    try {
      const response = await axiosInstance.get(`/fosWallet/getFosFinalRedeemableBalance?fos_id=${fosId}`);
      setFosFinalReedemableBalance(response?.data?.finalRedeemableBalance);
    } catch (error) {
      console.error("FOS API getFosDetails error:", error);
    }
  };

  const fetchWalletStanding = async () => {
    setLoadingStanding(true);
    try {
      const response = await axiosInstance.get(
        `/fosWallet/agreement-payout/wallet-standing?fos_id=${fosId}`
      );
      if (response.data?.success) {
        setWalletStanding(response.data.data);
        if (response.data.data.quarters?.length > 0) {
          setActiveQuarter(response.data.data.quarters[0].quarter);
        }
      }
    } catch (error) {
      console.error("Error fetching wallet standing:", error);
    } finally {
      setLoadingStanding(false);
    }
  };







  useEffect(() => {
  if (!isWalletVisible) {
    navigate('/Home', { replace: true });
    return;
  }
}, [isWalletVisible, navigate]);












  useEffect(() => {
    fetchFosWalletTransactions();
    getfosFinalReedemableBalance();
    fetchWalletStanding();
  }, [fosId]);

  useEffect(() => {
    fetchWalletBalance();
    dispatch(action.activeMenu("foswallet"));
  }, [fosId]);

  const filteredTransactions = transactionHistory
    .filter((txn) => {
      const lower = searchTerm.toLowerCase();
      return (
        txn.customer.toLowerCase().includes(lower) ||
        txn.leadDisplayId.toLowerCase().includes(lower) ||
        txn.projectName.toLowerCase().includes(lower)
      );
    })
    .filter((txn) => (filterType === "all" ? true : txn.type === filterType))
    .sort((a, b) => (sortDesc ? b.date - a.date : a.date - b.date));

  // Handler to open tooltip modal with full transaction object
  const handleInfoIconClick = (txn) => {
    setSelectedTransaction(txn);
    setTooltipModalOpen(true);
  };

  // Handler to close tooltip modal
  const handleTooltipModalClose = () => {
    setSelectedTransaction(null);
    setTooltipModalOpen(false);
  };









if (!isWalletVisible) {
  return null;
}





  return (
    <Box p={3} sx={{ bgcolor: "#f5f7fa", height: "100vh", overflow: "auto"}}>
      <Typography
        sx={{
          marginBottom: "10px",
          marginLeft: "10px",
          marginTop: "-10px",
          fontSize: { xs: "18px", sm: "24px", md: "27px" },
          fontWeight: "bold",
        }}
      >
        E-Wallet
      </Typography>

      <Box mb={3}>
        <PointsSummaryBanner
          balancePoints={balancePoints}
          onRedeem={() => setOpenModal(true)}
          walletStanding={walletStanding}
        />
      </Box>

      {/* Quarter Tabs + Stat Cards */}
      {loadingStanding && (
        <Box display="flex" alignItems="center" gap={1} mb={3}>
          <CircularProgress size={16} sx={{ color: '#1669f2' }} />
          <Typography sx={{ fontSize: '13px', color: '#64748b' }}>
            Loading incentive breakdown...
          </Typography>
        </Box>
      )}

      {walletStanding && walletStanding.quarters.length > 0 && (
        <Box mb={3}>
          <Box
            display="flex"
            gap={1}
            mb={1.5}
            sx={{ overflowX: 'auto', pb: 0.5, flexWrap: 'nowrap' }}
          >
            {walletStanding.quarters.map((q) => (
              <Button
                key={q.quarter}
                size="small"
                onClick={() => setActiveQuarter(q.quarter)}
                sx={{
                  borderRadius: '20px',
                  minWidth: 'auto',
                  px: 2,
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  fontSize: { xs: '12px', sm: '13px' },
                  backgroundColor: activeQuarter === q.quarter ? '#1669f2' : 'transparent',
                  color: activeQuarter === q.quarter ? '#fff' : '#1669f2',
                  border: '2px solid #1669f2',
                  '&:hover': {
                    backgroundColor: activeQuarter === q.quarter ? '#1257cc' : '#e8f0fe',
                  },
                }}
              >
                {q.quarter}
              </Button>
            ))}
          </Box>

          {(() => {
            const activeQ = walletStanding.quarters.find((q) => q.quarter === activeQuarter);
            if (!activeQ) return null;
            return (
              <Grid container spacing={1.5}>
                <Grid item xs={6} sm={3}>
                  <Box sx={{ background: 'linear-gradient(135deg,#dcfce7,#bbf7d0)', borderRadius: 2, p: { xs: 1.5, sm: 2 } }}>
                    <Typography sx={{ fontSize: { xs: '9px', sm: '11px' }, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px', opacity: 0.7, mb: 0.5 }}>
                      ✅ Incentive Redeemable
                    </Typography>
                    <Typography sx={{ fontSize: { xs: '14px', sm: '20px' }, fontWeight: 800, color: '#059669' }}>
                      {formatPoints(activeQ.incentive_redeemable)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={3}>
                  <Box sx={{ background: 'linear-gradient(135deg,#fef3c7,#fde68a)', borderRadius: 2, p: { xs: 1.5, sm: 2 } }}>
                    <Typography sx={{ fontSize: { xs: '9px', sm: '11px' }, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px', opacity: 0.7, mb: 0.5 }}>
                      🔒 Incentive Locked
                    </Typography>
                    <Typography sx={{ fontSize: { xs: '14px', sm: '20px' }, fontWeight: 800, color: '#d97706' }}>
                      {formatPoints(activeQ.incentive_locked)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={3}>
                  <Box sx={{ background: 'linear-gradient(135deg,#d1fae5,#6ee7b7)', borderRadius: 2, p: { xs: 1.5, sm: 2 } }}>
                    <Typography sx={{ fontSize: { xs: '9px', sm: '11px' }, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px', opacity: 0.7, mb: 0.5 }}>
                      📍 Site Visit Redeemable
                    </Typography>
                    <Typography sx={{ fontSize: { xs: '14px', sm: '20px' }, fontWeight: 800, color: '#047857' }}>
                      {formatPoints(activeQ.site_visit_redeemable || 0)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={3}>
                  <Box sx={{ background: 'linear-gradient(135deg,#fef3c7,#fde68a)', borderRadius: 2, p: { xs: 1.5, sm: 2 } }}>
                    <Typography sx={{ fontSize: { xs: '9px', sm: '11px' }, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px', opacity: 0.7, mb: 0.5 }}>
                      🔒 Site Visit Locked
                    </Typography>
                    <Typography sx={{ fontSize: { xs: '14px', sm: '20px' }, fontWeight: 800, color: '#d97706' }}>
                      {formatPoints(activeQ.site_visit_locked || 0)}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            );
          })()}
        </Box>
      )}

      <Grid container spacing={3} height="calc(100% - 170px)">
        <Grid item xs={12} md={8} height="100%">
          <Box height="100%" display="flex" flexDirection="column">
            <Typography fontWeight="bold" mb={1} sx={{ fontSize: { xs: "16px", sm: "18px" } }}>
              Recent Transactions
            </Typography>

            <Box display="flex" gap={1} mb={2} flexWrap="nowrap" width="100%" >
              <TextField
                size="small"
                placeholder="NAME,CUID,PROJECT"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  flex: 1,
                  minWidth: 0,
                  "& .MuiInputBase-input": {
                    fontSize: "2rem",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    fontSize: {
                       xs: "1.6rem", // Optional: slightly smaller placeholder for mobile
                       sm: "1.8rem",
                           },
                        opacity: 0.6,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="large" />
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                variant={filterType !== "all" ? "contained" : "outlined"}
                startIcon={<FilterAltIcon />}
                sx={{ whiteSpace: "nowrap", minWidth: "auto", px: 1.5, fontSize: "x-small" }}
                onClick={() =>
                  setFilterType((prev) =>
                    prev === "all" ? "credit" : prev === "credit" ? "debit" : "all"
                  )
                }
              >
                {filterType === "all"
                  ? "All"
                  : filterType.charAt(0).toUpperCase() + filterType.slice(1)}
              </Button>

              <Button
                variant="outlined"
                startIcon={
                  <SwapVertIcon
                    sx={{
                      transform: sortDesc ? "rotate(0deg)" : "rotate(180deg)",
                      transition: "transform 0.3s ease-in-out",
                    }}
                  />
                }
                sx={{ whiteSpace: "nowrap", minWidth: "auto", px: 1.5, fontSize: "x-small" }}
                onClick={() => setSortDesc(!sortDesc)}
              >
                {sortDesc ? "Latest" : "Oldest"}
              </Button>
            </Box>

            {/* Show loader while fetching */}
            {loadingTransactions ? (
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "300px",
                }}
              >
                <CircularProgress />
              </Box>
            ) : filteredTransactions.length === 0 ? (
              <Typography>No transactions found.</Typography>
            ) : (
              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: "auto",
                  paddingBottom: "150px",
                  pr: 1,
                  mb: { xs: "70px", sm: 0 },
                  maxHeight: {
                    xs: "calc(100vh - 360px)",
                    md: "calc(100vh - 270px)",
                  },
                  scrollbarWidth: "thin",
                  "&::-webkit-scrollbar": {
                    width: "100px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#ccc",
                    borderRadius: "3px",
                  },
                }}
              >
                {filteredTransactions.map((txn) => (
                  <Paper key={txn.id} sx={{ p: 2, mb: 2, position: "relative", overflow: "hidden" }}>
                    {txn.pointHistoryStatus === "locked" && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%) rotate(-20deg)",
                          fontSize: "36px",
                          fontWeight: 900,
                          color: "rgba(124, 58, 237, 0.10)",
                          pointerEvents: "none",
                          userSelect: "none",
                          whiteSpace: "nowrap",
                          letterSpacing: "4px",
                          zIndex: 0,
                          lineHeight: 1,
                        }}
                      >
                        🔒 LOCKED
                      </Box>
                    )}
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ position: "relative", zIndex: 1 }}>
                      <Box>
                        <Box display="flex" alignItems="center">
                          <Typography
                            fontWeight="bold"
                            sx={{ fontSize: { xs: "14px", sm: "16px" } }}
                          >
                            {txn.rewardType === "lead_agreement_done"
                              ? "Lead Agreement Done"
                              : txn.rewardType === "fos_basic"
                              ? "FOS Basic"
                              : txn.rewardType === "fos_incentive"
                              ? "FOS Incentive"
                              : txn.rewardType === "fos_site_visit"
                              ? "FOS Site Visit"
                              : "FOS Benefits"}
                          </Typography>

                          <IconButton
                            size="large"
                            sx={{ ml: 1 }}
                            onClick={() => handleInfoIconClick(txn)}
                          >
                            <InfoOutlinedIcon fontSize="large" />
                          </IconButton>
                        </Box>
                        <Typography sx={{ fontSize: { xs: "13px", sm: "14px" } }}>
                          {txn.customer}
                        </Typography>
                        <Typography sx={{ fontSize: { xs: "12px", sm: "13px" } }}>
                          {`CUID-VJ${txn.leadDisplayId?.slice(0, 8)}-${txn.leadDisplayId?.slice(8)}`}
                        </Typography>
                      </Box>
                      <Box textAlign="right">
                        <Typography
                          fontWeight="bold"
                          color={txn.type === "debit" ? "error" : "green"}
                          sx={{ fontSize: { xs: "14px", sm: "16px" } }}
                        >
                          {txn.type === "debit" ? `- ${txn.amount}` : `+ ${txn.amount}`}
                        </Typography>
                        <Typography sx={{ fontSize: { xs: "12px", sm: "13px" } }}>
                          {txn.dateFormatted} • {txn.timeFormatted}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: { xs: "12px", sm: "13px" },
                            fontWeight: txn.pointHistoryStatus === "locked" ? 700 : 400,
                            color:
                              txn.pointHistoryStatus === "locked"
                                ? "#7c3aed"
                                : txn.status === "processing"
                                ? "orange"
                                : "green",
                          }}
                        >
                          {txn.pointHistoryStatus === "locked"
                            ? "🔒 Locked"
                            : txn.status}
                          {txn.tds ? ` (TDS: ${txn.tds})` : ""}
                        </Typography>
                      </Box>
                    </Box>
                  </Paper>
                ))}
              </Box>
            )}
          </Box>
        </Grid>

        {/* Right side panel - Redeem Your Points — desktop only */}
        <Grid item xs={12} md={4} sx={{ display: { xs: "none", md: "block" } }}>
          <Paper
            sx={{
              p: 3,
              borderRadius: "12px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              bgcolor: "#fff",
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: "#1D4ED8", fontWeight: "bold", mb: 2 }}
            >
              Redeem Your Points:
            </Typography>

            <h1
              style={{
                backgroundColor: "#1669F2",
                color: "white",
                padding: "12px",
                borderRadius: "4px",
              }}
            >
              WITHDRAW REWARD POINTS
            </h1>

            {/* Step 1 */}
            <Box display="flex" alignItems="flex-start" mb={2}>
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: "#FEE2E2",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,
                }}
              >
                <img
                  src="https://img.icons8.com/ios-filled/24/FA5252/goal.png"
                  alt="step1"
                />
              </Box>
              <Box>
                <Typography fontWeight="bold">STEP 1</Typography>
                <Typography fontSize="0.9rem">
                  Choose where you would like to credit your earned reward points.
                </Typography>
              </Box>
            </Box>

            {/* Step 2 */}
            <Box display="flex" alignItems="flex-start" mb={2}>
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: "#FEF3C7",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,
                }}
              >
                <img
                  src="https://img.icons8.com/ios-filled/24/F59E0B/bank-cards.png"
                  alt="step2"
                />
              </Box>
              <Box>
                <Typography fontWeight="bold">STEP 2</Typography>
                <Typography fontSize="0.9rem">Enter your UPI id/Bank details.</Typography>
              </Box>
            </Box>

            {/* Step 3 */}
            <Box display="flex" alignItems="flex-start">
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: "#DCFCE7",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,
                }}
              >
                <img
                  src="https://img.icons8.com/ios-filled/24/10B981/qr-code.png"
                  alt="upi"
                />
              </Box>
              <Box>
                <Typography fontWeight="bold">STEP 3</Typography>
                <Typography fontSize="0.9rem">
                  Sit back and relax! Your reward points will be credited within 48 hours.
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <WithdrawPointsModal
        open={openModal}
        onClose={handleWithdrawModalClose}
        fosFinalReedemableBalance={fosFinalReedemableBalance}
        getfosFinalReedemableBalance={getfosFinalReedemableBalance}
      />

      {/* TooltipModal now receives entire transaction object */}
      <TooltipModal
        open={tooltipModalOpen}
        handleClose={handleTooltipModalClose}
        transactionDetails={selectedTransaction}
      />
    </Box>
  );
};

export default EWallet;
